import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { EntityPageFocusType } from '@xing-com/crate-common-graphql-types';
import { FormField } from '@xing-com/text-field';
import { Headline } from '@xing-com/typography';

import { MAX_CHARACTERS_ABOUT_TEXTAREA } from '../../config/constants';

import * as Styled from './about-edit-view.styles';

type AboutEditViewProps = {
  textValue: string;
  setTextValue: (value: string) => void;
  focusType?: EntityPageFocusType;
};

export const AboutEditView: React.FC<AboutEditViewProps> = ({
  textValue,
  setTextValue,
  focusType,
}) => {
  const { formatMessage } = useIntl();

  const titleCopy = useMemo(() => {
    switch (focusType) {
      case EntityPageFocusType.Publisher:
        return 'EP_ABOUT_EDIT_VIEW_TITLE_PUBLISHER';
      case EntityPageFocusType.Insider:
        return 'EP_ABOUT_EDIT_VIEW_TITLE_INSIDER';
      default:
        return 'EP_ABOUT_EDIT_VIEW_TITLE';
    }
  }, [focusType]);

  const textareaCopy = useMemo(() => {
    switch (focusType) {
      case EntityPageFocusType.Publisher:
        return 'EP_ABOUT_EDIT_VIEW_COPY_PUBLISHER';
      case EntityPageFocusType.Insider:
        return 'EP_ABOUT_EDIT_VIEW_COPY_INSIDER';
      default:
        return 'EP_ABOUT_EDIT_VIEW_COPY';
    }
  }, [focusType]);

  return (
    <>
      <Headline size="xxlarge" noMargin>
        <FormattedMessage id={titleCopy} />
      </Headline>
      <Styled.AboutEditBodyCopy size="medium">
        <FormattedMessage
          id={textareaCopy}
          values={{ maxCharacters: MAX_CHARACTERS_ABOUT_TEXTAREA }}
        />
      </Styled.AboutEditBodyCopy>

      <FormField
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          event.target.value = event.target.value.slice(
            0,
            MAX_CHARACTERS_ABOUT_TEXTAREA
          );
          setTextValue(event.target.value);
        }}
        value={textValue}
        label={formatMessage({
          id: 'EP_ABOUT_EDIT_VIEW_LABEL_INPUT_FIELD',
        })}
        maxCharacterCount={MAX_CHARACTERS_ABOUT_TEXTAREA}
        showCharacterCounter
        minRows={4}
        multiline
      />
    </>
  );
};
